module.exports = __webpack_public_path__ + "img/inactive-discord-circle.edb66cf.svg";